import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { InsuranceFlowLeadSnapshotResponse } from 'src/app/_types/insurance-flow.types';
import { Lead } from 'src/app/_types/lead.types';
import { getLeadStatusLabel, LeadStatus } from 'src/app/enums/lead-status.enum';

import { TaskLogMetadataDiffComponent } from '../task-log-metadata-diff/task-log-metadata-diff.component';

@Component({
  selector: 'app-task-log-lead-diff',
  standalone: true,
  imports: [CommonModule, TaskLogMetadataDiffComponent],
  templateUrl: './task-log-lead-diff.component.html',
  styleUrl: './task-log-lead-diff.component.css',
})
export class TaskLogLeadDiffComponent {
  @Input() currentSnapshot: InsuranceFlowLeadSnapshotResponse | Lead | null =
    null;

  @Input() baselineSnapshot: InsuranceFlowLeadSnapshotResponse | Lead | null =
    null;

  protected getLeadStatusLabel(status?: LeadStatus): string {
    if (!status) {
      return '-';
    }

    return getLeadStatusLabel(status);
  }

  protected isChanged<T>(currentValue?: T, previousValue?: T): boolean {
    return currentValue !== previousValue;
  }
}
